export default __webpack_public_path__ + "static/media/settings.2bfa07c2.svg";